module.exports = __webpack_public_path__ + "static/media/institution.5d4b53fd.jpg";